import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const ifilJointUContract = require('./ifilJointUContract.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.ifilJointUContractAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(ifilJointUContract.abi, contractAddress) : '',
}

const getIfilJointUAddress = () => {
    return contractAddress;
}

const getIfilJointUContract = () => {
    return contractConst.contract;
}

const jointUUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let lendContractAddress = $bizConfig.dmexLendrContractAddress;
    if (!!lendContractAddress && _contractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        return $web3js.send(getIfilJointUContract().methods.userDepositV2, [_pid, lendContractAddress, _amount], options, callback);
    }
    return $web3js.send(getIfilJointUContract().methods.userDeposit, [_pid, _amount], options, callback);
}

const jointUUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    let lendContractAddress = $bizConfig.dmexLendrContractAddress;

    let gasPromise;
    if (!!lendContractAddress && _contractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userDepositV2, [_pid, lendContractAddress, _amount], options);
    } else {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userDeposit, [_pid, _amount], options);
    }
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const jointUUserRedeem = async([_pid, _amount, _contractAddress, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let lendContractAddress = $bizConfig.dmexLendrContractAddress;
    let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;
    let dmexAggregatorContractAddress = $bizConfig.dmexAggregatorContractAddress;
    if (!!lendContractAddress && !!dmcMiningContractAddress && _principalContractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        // return $web3js.send(getIfilJointUContract().methods.userRedeemV4, [lendContractAddress, _pid, _amount], options, callback);
        return $web3js.send(getIfilJointUContract().methods.userRedeemV5, [dmcMiningContractAddress, lendContractAddress, _pid, _amount], options, callback);
    }
    if (!!dmcMiningContractAddress && !!dmexAggregatorContractAddress) {
        return $web3js.send(getIfilJointUContract().methods.userRedeemV3, [dmcMiningContractAddress, dmexAggregatorContractAddress, _pid, _amount], options, callback);
    } else if (!!dmcMiningContractAddress) {
        return $web3js.send(getIfilJointUContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options, callback);
    }
    return null;
    // return $web3js.send(getIfilJointUContract().methods.userRedeem, [_pid, _amount], options, callback);
}

const jointUUserRedeemEstimateSend = async([_pid, _amount, _contractAddress, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    let lendContractAddress = $bizConfig.dmexLendrContractAddress;
    let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;
    let dmexAggregatorContractAddress = $bizConfig.dmexAggregatorContractAddress;

    let gasPromise
    if (!!lendContractAddress && !!dmcMiningContractAddress && _principalContractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        // gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeemV4, [lendContractAddress, _pid, _amount], options);
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeemV5, [dmcMiningContractAddress, lendContractAddress, _pid, _amount], options);
    } else if (!!dmcMiningContractAddress && !!dmexAggregatorContractAddress) {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeemV3, [dmcMiningContractAddress, dmexAggregatorContractAddress, _pid, _amount], options);
    } else if (!!dmcMiningContractAddress) {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options);
    } else {
        // gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userRedeem, [_pid, _amount], options);
        return null;
    }
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const jointUUserIncome = ([_pid, _principalContractAddress], options, callback) => {
    _pid = $web3js.stringToBytes32(_pid);

    let lendContractAddress = $bizConfig.dmexLendrContractAddress;
    if (!!lendContractAddress && _principalContractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        return $web3js.send(getIfilJointUContract().methods.userIncomeV2, [_pid, lendContractAddress], options, callback);
    }
    return $web3js.send(getIfilJointUContract().methods.userIncome, [_pid], options, callback);
}

const jointUUserIncomeEstimateSend = async([_pid, _principalContractAddress], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    let lendContractAddress = $bizConfig.dmexLendrContractAddress;

    let gasPromise;
    if (!!lendContractAddress && _principalContractAddress.toLowerCase() == $erc20.getErc20Address("HFIL")) {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userIncomeV2, [_pid, lendContractAddress], options);
    } else {
        gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.userIncome, [_pid], options);
    }
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const jointUVendorWithdraw = ([_pid], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.send(getIfilJointUContract().methods.vendorWithdraw, [_pid], options);
}

const jointUVendorWithdrawEstimateSend = async([_pid], options) => {
    _pid = $web3js.stringToBytes32(_pid);

    let gasPromise = $web3js.estimateSend(getIfilJointUContract().methods.vendorWithdraw, [_pid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getJointUPoolInfo = ([_pid, ptoken, dli], options) => {
    _pid = $web3js.stringToBytes32(_pid);
    return $web3js.call(getIfilJointUContract().methods.getMiningPoolInfo, [_pid], options, handlePoolInfo, [ptoken, dli]);
}

const handlePoolInfo = async(res, ptoken, dli) => {
    // console.log("PoolInfo ", res)
    let index = 0;
    let totalPrincipalAmount = res[index++];
    let totalBenefitAmount = res[index++];
    let principalLiquidAmount = res[index++];
    let benefitLiquidAmount = res[index++];
    let principalExchangeAmount = res[index++];
    let benefitExchangeAmount = res[index++];
    let dpPrice = res[index++];

    totalPrincipalAmount = await $erc20.fromErc20Value(totalPrincipalAmount, ptoken);
    totalBenefitAmount = await $erc20.fromErc20Value(totalBenefitAmount, dli);
    principalLiquidAmount = await $erc20.fromErc20Value(principalLiquidAmount, ptoken);
    benefitLiquidAmount = await $erc20.fromErc20Value(benefitLiquidAmount, dli);
    principalExchangeAmount = await $erc20.fromErc20Value(principalExchangeAmount, ptoken);
    benefitExchangeAmount = await $erc20.fromErc20Value(benefitExchangeAmount, dli);
    dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

    return {
        totalPrincipalAmount,
        totalBenefitAmount,
        principalLiquidAmount,
        benefitLiquidAmount,
        principalExchangeAmount,
        benefitExchangeAmount,
        dpPrice,
    }
}

const getJointUPoolGlobalInfo = ([_pid], options) => {
    return $web3js.call(getIfilJointUContract().methods.getGlobalInfo, [_pid], options, handlePoolGlobalInfo);
}

const handlePoolGlobalInfo = async(res) => {
    // console.log("PoolGlobalInfo ", res)
    let index = 0;
    let ptoken = res[index++];
    let afil = res[index++];
    let dlp = res[index++];
    let dli = res[index++];
    let dpPrice = res[index++];
    let userDeposits = res[index++];
    let userGainPrincipals = res[index++];
    let userGainBenefits = res[index++];
    let plateformBenefits = res[index++];
    let vendorGains = res[index++];
    let vendorReleasePrincipals = res[index++];
    let vendorReleaseBenefits = res[index++];
    let state = res[index++];
    let active = res[index++];

    userDeposits = await $erc20.fromErc20Value(userDeposits, ptoken);
    userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
    userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, dli);
    plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, dli);
    vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
    vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
    vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, dli);

    dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

    return {
        ptoken,
        afil,
        dlp,
        dli,
        dpPrice,
        userDeposits,
        userGainPrincipals,
        userGainBenefits,
        plateformBenefits,
        vendorGains,
        vendorReleasePrincipals,
        vendorReleaseBenefits,
        state,
        active,
    }
}

const getJointUUserIncome = ([_pid], options) => {
    return $web3js.call(getIfilJointUContract().methods.getUserIncome, [_pid], options, $web3js.fromWei);
}

export default {
    getIfilJointUAddress,
    getIfilJointUContract,
    jointUUserDeposit,
    jointUUserDepositEstimateSend,
    jointUUserRedeem,
    jointUUserRedeemEstimateSend,
    jointUUserIncome,
    jointUUserIncomeEstimateSend,
    jointUVendorWithdraw,
    jointUVendorWithdrawEstimateSend,
    getJointUPoolInfo,
    getJointUPoolGlobalInfo,
    getJointUUserIncome,
}


// WEBPACK FOOTER //
// ./src/lib/contract/ifilJointU/index.js